module.exports = __webpack_public_path__ + "static/media/self_collage.57d4039d.webp";